/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  Grid,
  useTheme,
  Typography,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import EuroIcon from '@mui/icons-material/Euro';
import { useTranslation } from "react-i18next";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import Icon from "./Icon";
import { useMyContext } from "../../MyContext";

const Image = styled("img")(({ theme }) => ({
  maxWidth: "100%",
  overflow: "hidden",
  maxHeight: "700px",
  width: "405px",
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontFamily: theme.typography.fontFamily,
  "&:hover": {
    color: theme.palette.primary.red,
  },
}));

const Price = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
  [theme.breakpoints.up("sm")]: {
    textAlign: "center",
  },
  color: theme.palette.primary.red,
  "&::after": {
    content: '"€"',
  },
  margin: 1,
}));

const Ingredients = styled(Typography)(({ theme }) => ({
  // fontStyle: "italic",
  whiteSpace: "normal",
  marginTop: "0.75rem",
  lineHeight: "1.79rem",
  fontSize: "1.75rem",
  textAlign: "center",
  [theme.breakpoints.up("sm")]: {
    textAlign: "center",
  },
}));

function ModalMenuItem ( { menu, item, onClose } )
{
  const { onlyMenuFromParams } = useMyContext();
  const isBeach = onlyMenuFromParams == 2
  
  const handleDialogContentClick = (event) => {
    event.stopPropagation();
    onClose();
  };

  const [menuItem, setmenuItem] = useState(item);
  const { t} = useTranslation();
  const theme = useTheme();

  const [imageLoading, setImageLoading] = useState(true);

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => (prev + 5) % 100);
    }, 100);
    return () => clearInterval(timer);
  }, []);

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const returnMesurements = (cat) => {
    if (cat === "Drinks" || cat === "Fruit Juices") return "ml";
    else return "gr";
  };

  const englishItem = useMemo(() => {
    return menu
      .find((langObj) => langObj.langKey === "en")
      ?.items.find((menuItem) => menuItem.id === item.id);
  }, [menu, item]);

  const { servingTime } = englishItem;
  return (
    <Dialog open={!!menuItem} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        bgcolor="primary.main"
        color="text.light"
        mb={2}
        variant="h4"
        align="center"
      >
        {menuItem.menuNumber} {menuItem ? menuItem?.title : ""}
      </DialogTitle>
      <DialogContent onClick={handleDialogContentClick}>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              direction: "flex",
            }}
          >
            {englishItem?.image && (
              <Image
                src={englishItem?.image}
                alt={englishItem?.title}
                onLoad={handleImageLoad}
              />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={englishItem?.image ? 6 : 12}
            sx={{ py: 1, pl: 1 }}
          >
            <Grid
              container
              sx={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                justifyContent: "space-between",
              }}
            >
              <Price variant="h3">
                {" "}
                {isBeach ? englishItem?.beachPrice : englishItem?.price}
              </Price>
              {englishItem?.per && (
                <Ingredients> for {englishItem.per}</Ingredients>
              )}
              {englishItem?.weight && (
                <Ingredients>
                  {" "}
                  {menuItem.weight} {returnMesurements(menuItem.category)}
                </Ingredients>
              )}
              {menuItem?.ingredients && (
                <Ingredients>{menuItem.ingredients}</Ingredients>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              mt: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            {englishItem.beachMenu && (
              <Icon
                url="/icons/beach-menu7.png"
                text={ t( "menuItem.beach" ) }
                textcolor="primary.dark"
              />
            )}
            {englishItem.restaurantMenu && (
              <Icon
                url="/icons/rest-menu1.png"
                text={ t( "menuItem.rest" ) }
                textcolor="primary.dark"
              />
            ) }
            { englishItem.beachMenu && englishItem.restaurantMenu && (
              <>   <EuroIcon sx={{ color: "white" }} /> <Typography variant="body1"> {t("menuItem.vary")}</Typography></>
            ) }
            {englishItem?.servingTime && (
              <Icon
                url="/icons/serv.png"
                text={t("modalMenu.servingTimeMessage", servingTime)}
                textcolor="primary.dark"
              />
              // <Stack
              //   direction="row"
              //   justifyContent="center"
              //   alignItems="center"
              //   spacing={1}
              // >
              //   <SmsFailedIcon />
              //   <Typography variant="body1" color="primary.red">
              //     {t("modalMenu.servingTimeMessage", servingTime)}
              //   </Typography>
              // </Stack>
            )}
            {/* // If this items is only for restaurant, show this message in Modal
            window */}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("menu.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalMenuItem;
